import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import Observer from '@researchgate/react-intersection-observer';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import Checkbox from '../../../Checkbox';
import List from '../../../List';
import withForwardedRef from '../../../../decorators/withForwardedRef';
import Clickable from '../../../Clickable';
import { ICONS } from '../../../../constants';
import Label from '../../../Label';
import { filtersMessages as messages } from '../../../../defineMessages';
import Icon from '../../../Icon';

import s from './Filters.scss';
import { sortBy, physicalProductFunc } from '../../../../helpers';

const TITLE_HEIGHT = 36;

class Filters extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    items: PropTypes.shape().isRequired,
    onChange: PropTypes.func.isRequired,
    group: PropTypes.string.isRequired,
    order: PropTypes.number.isRequired,
    forwardedRef: PropTypes.shape(),
    products: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  };

  static defaultProps = {
    forwardedRef: null,
  };

  constructor(props) {
    super(props);
    this.titleRef = React.createRef();
    this.menuRef = React.createRef();
  }

  state = {
    isSticky: false,
    titleTop: 0,
  };

  componentDidMount() {
    this.getElementHeights(this.props.order);
  }

  getElementHeights = order => {
    const titleTop = TITLE_HEIGHT * order;
    this.setState({
      titleTop,
    });
  };

  scrollTo = offset => {
    this.props.forwardedRef.scrollTo({
      top: offset,
      left: 0,
      behavior: 'smooth',
    });
  };

  expand = event => {
    event.preventDefault();

    const position =
      this.menuRef.current.offsetTop - TITLE_HEIGHT * (this.props.order + 1);
    this.scrollTo(position);
  };

  handleIntersection = ({ isIntersecting }) => {
    this.setState({
      isSticky: !isIntersecting,
    });
  };

  render() {
    const {
      title,
      items,
      onChange,
      group,
      forwardedRef,
      products,
    } = this.props;
    const itemKeys = Object.keys(items);
    if (itemKeys.length === 0) {
      return null;
    }

    itemKeys.forEach(key => {
      items[key].key = key;
    });

    const sorted = Object.values(items).sort(sortBy('label'));

    const { titleTop, isSticky } = this.state;
    const options = {
      onChange: this.handleIntersection,
      root: forwardedRef,
      rootMargin: `-${titleTop}px 0px 0px 0px`,
    };

    return (
      <Fragment>
        <Observer {...options}>
          <div style={{ height: 1 }} />
        </Observer>
        <div
          className={cx(
            physicalProductFunc(products, group) ? null : s.title,
            isSticky && s.isSticky,
          )}
          style={{
            top: `${titleTop}px`,
            height: TITLE_HEIGHT,
            display: physicalProductFunc(products, group) ? 'block' : 'none',
          }}
          ref={this.titleRef}
        >
          <Clickable onClick={this.expand}>
            <Label bold uppercase>
              <FormattedMessage {...messages[title]} />
            </Label>
          </Clickable>
          <div className={s.arrow} role="presentation">
            <Icon name={ICONS.CHEVRON_DOWN} size={12} />
          </div>
        </div>
        {physicalProductFunc(products, group) && (
          <div ref={this.menuRef} className={s.list}>
            <List container spacing={16} direction="column">
              {sorted &&
                Object.keys(sorted).map(key => (
                  <List component="li" item key={sorted[key].key}>
                    <Checkbox
                      name={sorted[key].key}
                      label={sorted[key].label}
                      showLabel
                      checked={sorted[key].checked}
                      onChange={event =>
                        onChange(sorted[key].key, event.target.checked, group)
                      }
                    />
                  </List>
                ))}
            </List>
          </div>
        )}
      </Fragment>
    );
  }
}
const mapState = state => ({
  products: state.shop.data,
});

export default compose(
  withForwardedRef,
  injectIntl,
  withStyles(s),
  connect(mapState),
)(Filters);
